import Head from 'next/head'

import isServer from '../../../../utils/is-server'

const description = `LivDemy Subscription Pricing`
const cover = isServer()
  ? `/icons/icon-512x512.png`
  : `${window.location.origin}/icons/icon-512x512.png`

const Meta = () => {
  return (
    <Head>
      <title>Pricing | LivDemy</title>
      <meta content={description} name='description' property='description' />
      <meta
        content={description}
        name='og:description'
        property='og:description'
      />
      <meta content={cover} name='og:image' property='og:image' />
      <meta content={cover} name='og:image:secure' property='og:image:secure' />
      <meta
        content={cover}
        name='og:image:secure_url'
        property='og:image:secure_url'
      />
    </Head>
  )
}

export default Meta
